import styled from "styled-components";

export const Container = styled.div`
  padding-top: 35px;
  padding-bottom: 60px;
  padding-left: ${({ theme }) =>
    theme.layout.content.paddingHorizontal.desktop}px;
  padding-right: ${({ theme }) =>
    theme.layout.content.paddingHorizontal.desktop}px;

  @media only screen and (max-width: 768px) {
    padding-left: ${({ theme }) =>
      theme.layout.content.paddingHorizontal.ipad}px;
    padding-right: ${({ theme }) =>
      theme.layout.content.paddingHorizontal.ipad}px;
  }
  @media only screen and (max-width: 560px) {
    padding-top: 16px;
    padding-bottom: 41px;
    padding-left: ${({ theme }) =>
      theme.layout.content.paddingHorizontal.mobile}px;
    padding-right: ${({ theme }) =>
      theme.layout.content.paddingHorizontal.mobile}px;
  }
`;

export const Title = styled.h1`
  ${({ theme }) => theme.textStyles.sectionTitle};
  padding-bottom: 25px;
  margin-bottom: 0;
  @media only screen and (max-width: 560px) {
    font-size: 30px;
    padding-bottom: 16px;
  }
`;

export const FAQsContainer = styled.div`
  
`;
